import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { FilteredPageQuery, IonApiClientService } from 'shared';
import { UploadPhotoDTO } from '../models/upload-photo';
import { IProductProviderService } from './iproductprovider.service';

@Injectable()
// @Injectable({ providedIn: 'root' })
export class ProductProviderService implements IProductProviderService {
    constructor(public _ionApiClientService: IonApiClientService) {}

    public getProductList(
        filteredPageQuery: FilteredPageQuery,
        loadingText: string
    ): Observable<any> {
        return this._ionApiClientService.post<FilteredPageQuery>(
            'productprovider/get-page',
            filteredPageQuery,
            null,
            loadingText
        );
    }

    public uploadPhoto(uploadPhotoDTO: UploadPhotoDTO): Observable<any> {
        return this._ionApiClientService.post<UploadPhotoDTO>(
            'productprovider/upload-photo',
            uploadPhotoDTO,
            null,
            'Uploading photo',
            false,
            'common.upload-success'
        );
    }
}
